import { FaSeedling, FaBookOpen, FaPhotoVideo, FaYinYang } from 'react-icons/fa';

const features = [
    { 
        id: 1,
        icon: <FaSeedling />,
        title: 'features.item1.title',
        description: 'features.item1.description',
        link: '/Uslugi/1'
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: 'features.item2.title',
        description: 'features.item2.description',
        link: '/Uslugi/2'   
    },
    {
        id: 3,
        icon: <FaPhotoVideo />,
        title: 'features.item3.title',
        description: 'features.item3.description',
        link: '/Uslugi/3'
    },
    {
        id: 4,
        icon: <FaYinYang />,
        title: 'features.item4.title',
        description: 'features.item4.description',
        link: '/Psychologia-zieleni/Sesje'
    },
];

export default features;